export enum RoutePaths {
  home = "/",
  work = "/work",
  gallery = "/gallery/:gallery",
  photoscout = "/photoscout",
  about = "/about",
  share = "/share",
  social = "/social",
}
